/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-parallax.js
 *
 * スクロールに合わせて実行するパララックスアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * パララックス - テキスト
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setparallaxText = () => {
	/**
	 * 処理
	 */
	setparallaxText_X();
	setparallaxText_Y();

	/**
	 * X軸
	 */
	function setparallaxText_X() {
		gsap.utils.toArray(".parallaxText.--X").forEach((parallaxText_X, i) => {
			let start = JSON.parse(parallaxText_X.dataset.start);
			let end = JSON.parse(parallaxText_X.dataset.end);
			gsap.set(parallaxText_X, {
				xPercent: start,
			});
			gsap.registerEffect({
				name: "parallaxText_X",
				effect: (targets, config) => {
					return gsap.to(targets, {
						xPercent: end,
						scrollTrigger: {
							trigger: targets,
							start: "top 80%",
							end: "bottom top",
							scrub: 2,
							// markers: true,
						},
					});
				},
			});
			gsap.effects.parallaxText_X(parallaxText_X);
		});
	}

	/**
	 * Y軸
	 */
	function setparallaxText_Y() {
		gsap.utils.toArray(".parallaxText.--Y").forEach((parallaxText_Y, i) => {
			let start = JSON.parse(parallaxText_Y.dataset.start);
			let end = JSON.parse(parallaxText_Y.dataset.end);
			gsap.set(parallaxText_Y, {
				yPercent: start,
			});
			gsap.registerEffect({
				name: "parallaxText_Y",
				effect: (targets, config) => {
					return gsap.to(targets, {
						yPercent: end,
						scrollTrigger: {
							trigger: targets,
							start: "top 80%",
							end: "bottom top",
							scrub: 2,
							// markers: true,
						},
					});
				},
			});
			gsap.effects.parallaxText_Y(parallaxText_Y);
		});
	}
};

/**
 * パララックス - img
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setparallaxImg = () => {
	/**
	 * 処理
	 */
	setparallaxImg_X();
	setparallaxImg_Y();

	/**
	 * X軸
	 */
	function setparallaxImg_X() {
		gsap.utils.toArray(".parallaxImg.--X").forEach((parallaxImg_X, i) => {
			let start = JSON.parse(parallaxImg_X.dataset.start);
			let end = JSON.parse(parallaxImg_X.dataset.end);
			gsap.set(parallaxImg_X, {
				xPercent: start,
			});
			gsap.registerEffect({
				name: "parallaxImg_X",
				effect: (targets, config) => {
					return gsap.to(targets, {
						xPercent: end,
						scrollTrigger: {
							trigger: targets,
							start: "top 80%",
							end: "bottom top",
							scrub: 2,
							// markers: true,
						},
					});
				},
			});
			gsap.effects.parallaxImg_X(parallaxImg_X);
		});
	}

	/**
	 * Y軸
	 */
	function setparallaxImg_Y() {
		gsap.utils.toArray(".parallaxImg.--Y").forEach((parallaxImg_Y, i) => {
			let start = JSON.parse(parallaxImg_Y.dataset.start);
			let end = JSON.parse(parallaxImg_Y.dataset.end);
			gsap.set(parallaxImg_Y, {
				yPercent: start,
			});
			gsap.registerEffect({
				name: "parallaxImg_Y",
				effect: (targets, config) => {
					return gsap.to(targets, {
						yPercent: end,
						ease: "none",
						scrollTrigger: {
							trigger: targets,
							start: "top 80%",
							end: "bottom top",
							scrub: 2,
							// markers: true,
						},
					});
				},
			});
			gsap.effects.parallaxImg_Y(parallaxImg_Y);
		});
	}

	// アニメーションとスクロールトリガーの設定を行う関数
	function setupAnimationAndTrigger(selector, speed, percent, direction) {
		gsap.utils.toArray(selector).forEach((element) => {
			// 要素の幅または高さを取得します
			const dimension = direction === "xPercent" ? element.getBoundingClientRect().width : element.getBoundingClientRect().height;
			// 持続時間を計算します（幅または高さ ÷ 速度）
			const duration = dimension / speed;

			const slideAnimation = gsap.to(element, {
				[direction]: percent,
				duration: duration,
				ease: "none",
				paused: true, // 初期状態ではアニメーションを一時停止
				repeat: -1, // 無限に繰り返し
			});

			ScrollTrigger.create({
				trigger: element,
				start: "top bottom", // 要素の上端がビューポートの下端に達した時
				end: "bottom top", // 要素の下端がビューポートの上端を超えた時
				onEnter: () => slideAnimation.resume(), // ビューポートに入ったらアニメーション再開
				onLeave: () => slideAnimation.pause(), // ビューポートから出たらアニメーション一時停止
				onEnterBack: () => slideAnimation.resume(), // ビューポートに戻ったら再開
				onLeaveBack: () => slideAnimation.pause(), // ビューポートから後ろ向きに出たら停止
				// markers: true, // 開発時にはマーカーを表示して確認
				toggleActions: "play none none none",
				// 上記では入場時にのみアクションを設定していますが、必要に応じて調整してください。
			});
		});
	}
	setupAnimationAndTrigger(".slideKvX", 50, -100, "xPercent");
};

/**
 * 処理
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function scrollTriggerParallax() {
	// setparallaxText();
	setparallaxImg();
}

/**
 *  Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { scrollTriggerParallax };
